module.exports = __webpack_public_path__ + "static/media/searchIconDark.f312211c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/searchIconDark.svg
// module id = 57
// module chunks = 0